document.addEventListener('DOMContentLoaded', function () {
    const animationContainer = document.querySelector('.cover--animation');
    if (animationContainer) {
        const imageContainers = animationContainer.querySelectorAll('.anim--wrap');
        let currentIndex = 0;

        // Initially hide all images except the first one
        imageContainers.forEach((container, index) => {
            container.style.opacity = index === 0 ? '1' : '0';
        });

        // Function to cycle through images
        function cycleImages() {
            // Hide current image
            imageContainers[currentIndex].style.opacity = '0';

            // Move to next image
            currentIndex = (currentIndex + 1) % imageContainers.length;

            // Show next image
            imageContainers[currentIndex].style.opacity = '1';
        }

        // Start the animation loop every 1 second
        setInterval(cycleImages, 500);
    }
});